export const ASSISTANT_IDS = {
  // PAGE: "928e9f64-71da-5592-8bd4-608b92e05b9a",
  PAGE: "Page",
  PAGE_REACT: "Page: ReACT",
  PAGE_COPY: "Page: Copy",
  PAGE_SECTIONS: "Page: Sections",
  CAMPAIGN: "Campaign",
  // COPY: "Copy",
  COPY: "Copy: ReACT",
  RESEARCH: "Research",
  SUPER_AGENT: "Supervisor",
};